/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import ModernBrowserInterstitial from 'app/components/interstitials/ModernBrowserInterstitial';
import CompanyTypeRestrictor from 'app/components/providers/CompanyTypeRestrictor';
import AuthRoute from 'app/components/shared/AuthRoute';
import { CompanyTypeId } from 'app/constants/user';
import LoadingScreen from 'app/pages/shared/LoadingScreen';
import ClaimRelationshipProvider from 'app/state/ClaimRelationshipContext/Provider';
import { retry } from 'app/utils/lib/file';

import PayeeRoutesLayout from '../../Layouts/PayeeRoutesLayout';

const LazyBrokerRoute = lazy(() => retry(() => import('app/pages/payee/Broker')));
const LazyCrediNoteRoute = lazy(() => retry(() => import('app/pages/payee/CreditNote')));
const LazyDashboardRoute = lazy(() => retry(() => import('app/pages/payee/Dashboard')));
const LazyFourOhFour = lazy(() => retry(() => import('app/pages/error/FourOhFour')));
const LazyInvoiceRoute = lazy(() => retry(() => import('app/pages/payee/Invoice')));
const LazyInvoiceSuccessRoute = lazy(() => retry(() => import('app/pages/payee/InvoiceSuccess')));
const LazyInvoicesRoute = lazy(() => retry(() => import('app/pages/payee/Invoices')));
const LazyAddBankAccountRoute = lazy(() =>
  retry(() => import('app/pages/payee/UnclaimedRelationships/AddBankAccount')));
const LazyNoRoleLandingPage = lazy(() => retry(() => import('app/pages/payee/Paperwork/NoRoleLandingPage')));
const LazyPaperworkRoute = lazy(() => retry(() => import('app/pages/payee/Paperwork')));
const LazyPaperworkCreateRoute = lazy(() => retry(() => import('app/pages/payee/PaperworkCreate')));
const LazyPaperworkEditRoute = lazy(() => retry(() => import('app/pages/payee/PaperworkEdit')));
const LazyPaperworkShowRoute = lazy(() => retry(() => import('app/pages/payee/PaperworkShow')));
const LazyPaperworkSuccessRoute = lazy(() => retry(() => import('app/pages/payee/PaperworkSuccess')));
const LazyPaymentRoute = lazy(() => retry(() => import('app/pages/payee/Payment')));
const LazyPaymentsRoute = lazy(() => retry(() => import('app/pages/payee/Payments')));
const LazyProfileRoute = lazy(() => retry(() => import('app/pages/payee/Profile')));
const LazyRelationshipRoute = lazy(() => retry(() => import('app/pages/payee/Relationship')));
const LazyRelationshipsSuccessRoute = lazy(() => retry(() => import('app/pages/payee/RelationshipsSuccess')));
const LazySelectCarrierRoute = lazy(() => retry(() => import('app/pages/payee/SelectCarrier')));
const LazyTermsRoute = lazy(() => retry(() => import('app/pages/payee/Relationship/TermsOfServicePage')));
const LazyUnclaimedRelationshipRoute = lazy(() => retry(() => import('app/pages/payee/UnclaimedRelationship')));
const LazyUnclaimedRelationshipsRoute =
    lazy(() => retry(() => import('app/pages/payee/UnclaimedRelationships')));
const LazyUserCreateRoute = lazy(() => retry(() => import('app/pages/payee/UserCreate')));
const LazyUserEditRoute = lazy(() => retry(() => import('app/pages/payee/UserEdit')));

export const Broker = (props: any) => <LazyBrokerRoute {...props} />;
export const CreditNote = (props: any) => <LazyCrediNoteRoute {...props} />;
export const Dashboard = (props: any) => <LazyDashboardRoute {...props} />;
export const FourOhFour = (props: any) => <LazyFourOhFour {...props} />;
export const Invoice = (props: any) => <LazyInvoiceRoute {...props} />;
export const InvoiceSuccess = (props: any) => <LazyInvoiceSuccessRoute {...props} />;
export const Invoices = (props: any) => <LazyInvoicesRoute {...props} />;
export const AddBankAccount = (props: any) => <LazyAddBankAccountRoute {...props} />;
export const NoRoleLandingPage = (props: any) => <LazyNoRoleLandingPage {...props} />;
export const Paperwork = (props: any) => <LazyPaperworkRoute {...props} />;
export const PaperworkCreate = (props: any) => <LazyPaperworkCreateRoute {...props} />;
export const PaperworkEdit = (props: any) => <LazyPaperworkEditRoute {...props} />;
export const PaperworkShow = (props: any) => <LazyPaperworkShowRoute {...props} />;
export const PaperworkSuccess = (props: any) => <LazyPaperworkSuccessRoute {...props} />;
export const Payment = (props: any) => <LazyPaymentRoute {...props} />;
export const Payments = (props: any) => <LazyPaymentsRoute {...props} />;
export const Profile = (props: any) => <LazyProfileRoute {...props} />;
export const Relationship = (props: any) => <LazyRelationshipRoute {...props} />;
export const RelationshipsSuccess = (props: any) => <LazyRelationshipsSuccessRoute {...props} />;
export const SelectCarrier = (props: any) => <LazySelectCarrierRoute {...props} />;
export const TermsOfServicePage = (props: any) => <LazyTermsRoute {...props} />;
export const UnclaimedRelationship = (props: any) => <LazyUnclaimedRelationshipRoute {...props} />;
export const UnclaimedRelationships = (props: any) => <LazyUnclaimedRelationshipsRoute {...props} />;
export const UserCreate = (props: any) => <LazyUserCreateRoute {...props} />;
export const UserEdit = (props: any) => <LazyUserEditRoute {...props} />;

export const PayeeLayout = () => {
  return (
    <AuthRoute>
      <CompanyTypeRestrictor permittedCompanyTypeIds={[CompanyTypeId.Payee]}>
        <PayeeRoutesLayout
          body={(
            <ClaimRelationshipProvider>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </ClaimRelationshipProvider>
          )}
        />

        <ModernBrowserInterstitial />
      </CompanyTypeRestrictor>
    </AuthRoute>
  );
};
